const PP_ADMIN_TOKEN = "PP_ADMIN_TOKEN";
const PP_ADMIN_REFERRER = "PP_ADMIN_REFERRER";

export { PP_ADMIN_TOKEN, PP_ADMIN_REFERRER };
